export default __webpack_public_path__ + "static/media/illustration-algohealth-w@2x.65b554f9.png";